import * as React from 'react';
import classNames from 'classnames';
import useId from '../../utils/useId';
import css from './file-input.module.scss';

type Props = {
  accept?: string;
  className?: string;
  inputLabel: string | React.ReactNode;
  isDisabled?: boolean;
  isMultiple?: boolean;
  labelSpanClass?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FileInput = ({
  accept,
  className,
  inputLabel,
  isMultiple = true,
  isDisabled = false,
  labelSpanClass,
  onChange,
}: Props) => {
  const inputRef = React.useRef(null);
  const isTextLabel = typeof inputLabel === 'string';

  const htmlId = useId('file-input-');
  const fullClassName = classNames(className, css.fileInput, {
    [css.disabled]: isDisabled,
  });
  const spanClassName = classNames(css.inputLabel, labelSpanClass, {
    btn: isTextLabel,
    [css.buttonStyles]: isTextLabel,
  });

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleKeyUp = (event: any) => {
    if (event.key === 'Enter' || event.key === ' ') {
      if (inputRef.current) {
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339
        inputRef.current.click();
      }
    }
  };

  return (
    <label className={fullClassName} htmlFor={htmlId}>
      <span
        aria-controls={htmlId}
        className={spanClassName}
        onKeyUp={handleKeyUp}
        role="button"
        tabIndex={isDisabled ? -1 : 0}
      >
        {inputLabel}
      </span>
      <input
        ref={inputRef}
        accept={accept}
        disabled={isDisabled}
        id={htmlId}
        multiple={isMultiple}
        onChange={onChange}
        type="file"
      />
    </label>
  );
};
export { FileInput };
export default FileInput;
